function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React, { Fragment } from 'react';
import get from 'lodash/get';
import Widget from 'components/Widget';
import { DailyGlucoseProfile } from 'modules/AmbulatoryGlucoseProfile';
import * as constants from '../../../constants';
import messages from '../../../messages';
import { Indicators } from '../../../modules/Kpi';
import MeasurementsTableWidget from '../../MeasurementsTableWidget';
import GlucoseLevelDistributionWidget from '../../GlucoseLevelDistributionWidget';
import MixedDistributionWidget from '../../MixedDistributionWidget';
import SummaryTableWidget from '../../SummaryTableWidget';
import TrendChartWidget from '../../TrendChartWidget';
import ChartControls from '../../TrendChartWidget/ChartControls';
import AgpTrendChartWidget from '../../AgpTrendChartWidget';
import PrintableAgpBgmReport from '../../PrintableAgpBgmReport';
import BloodGlucoseConcentrationReport from '../../BloodGlucoseConcentrationReport';
import GlucoseConcentrationLevelsWidget from '../../Widgets/GlucoseConcentrationLevelsWidget';
import styles from '../Results.pcss';
import PrintableHeader from '../components/PrintableHeader';
import { WIDGET_NAMES } from './constants';
const getPatientName = (ctx, field)=>get(_object_spread({}, ctx.accountPatientProfile, ctx.patient), field, '');
const renderKpis = (ctx)=>/*#__PURE__*/ _jsx(Indicators, {
        readings: ctx.readings,
        preMealReadings: ctx.preMealReadings,
        postMealReadings: ctx.postMealReadings,
        daysWithReadings: ctx.daysWithReadings,
        daysWithoutReadings: ctx.daysWithoutReadings,
        readingsWithoutFlag: ctx.readingsWithoutFlag,
        isInProgress: ctx.isInProgress,
        onAddNote: ctx.onAddNote
    }, "KPIs");
export const widgetsRegistry = {
    AgpTrendChartWidget: (ctx)=>/*#__PURE__*/ _jsx(AgpTrendChartWidget, {
            statsData: ctx.statsData,
            start: ctx.start,
            end: ctx.end,
            isInProgress: ctx.isInProgress,
            onDatesChange: ctx.onDatesChange
        }, "AgpTrendChartWidget"),
    TrendChartWidget: (ctx)=>/*#__PURE__*/ _jsx(TrendChartWidget, {
            renderControls: false,
            phiSetDocumentId: ctx.phiSetDocumentId,
            phiSet: ctx.resultsPhiSet,
            data: ctx.statsData,
            dataType: ctx.patient && ctx.patient.dataType || 'BGM',
            relatedData: ctx.relatedData,
            timeSeriesResources: ctx.timeSeriesResources,
            measurements: ctx.measurements,
            start: ctx.start,
            end: ctx.end,
            conversion: ctx.conversion,
            standards: ctx.standards,
            customRanges: ctx.customRanges,
            activePointTimestamp: ctx.activeMeasurementTimestamp,
            renderDatePresets: ctx.renderDatePresets,
            renderFlagFilters: ctx.renderFlagFilters,
            onSetActivePointTimestamp: ctx.onSetActiveMeasurementTimestamp,
            onUpdatePhiSet: ctx.onUpdatePhiSet,
            onAddNote: ctx.onAddNoteRaw,
            isReadOnly: ctx.isReadOnly,
            isInProgress: ctx.isInProgress,
            highlightedReadings: ctx.highlightedReadings
        }, "TrendChartWidget"),
    ChartControls: (ctx)=>/*#__PURE__*/ _jsx(Widget, {
            widgetId: constants.CHART_CONTROLS_WIDGET,
            isNoHeader: true,
            children: /*#__PURE__*/ _jsx(ChartControls, {
                start: ctx.start,
                end: ctx.end,
                renderDatePresets: ctx.renderDatePresets,
                renderFlagFilters: ctx.renderFlagFilters,
                isInProgress: ctx.isInProgress
            })
        }, "ChartControlsWidget"),
    MeasurementsTableWidget: (ctx)=>/*#__PURE__*/ _jsx(MeasurementsTableWidget, {
            conversion: ctx.conversion,
            standards: ctx.standards,
            readings: ctx.readings,
            timeSeriesResources: ctx.timeSeriesResources,
            relatedData: ctx.relatedData,
            customRanges: ctx.customRanges,
            activeReadingTimestamp: ctx.activeMeasurementTimestamp,
            headerMessage: messages.headers.measurementsTable,
            isInProgress: ctx.isInProgress
        }, "MeasurementsTableWidget"),
    MeasurementsTableWidgetWithoutMyDownloads: (ctx)=>/*#__PURE__*/ _jsx(MeasurementsTableWidget, {
            conversion: ctx.conversion,
            standards: ctx.standards,
            readings: ctx.readings,
            timeSeriesResources: ctx.timeSeriesResources,
            relatedData: ctx.relatedData,
            customRanges: ctx.customRanges,
            activeReadingTimestamp: ctx.activeMeasurementTimestamp,
            headerMessage: messages.headers.measurementsTable,
            isInProgress: ctx.isInProgress,
            isMyDownloadsHidden: true,
            onCellClick: ctx.onSetActiveMeasurementTimestamp
        }, "MeasurementsTableWidgetWithoutMyDownloads"),
    GlucoseLevelDistributionWidget: (ctx)=>/*#__PURE__*/ _jsx(GlucoseLevelDistributionWidget, {
            flagFilters: ctx.flagFilters,
            standards: ctx.standards,
            readings: ctx.readings,
            isInProgress: ctx.isInProgress,
            onAddNote: ctx.onAddNote
        }, "GlucoseLevelDistributionWidget"),
    MixedDistributionWidget: (ctx)=>/*#__PURE__*/ _jsx(MixedDistributionWidget, {
            conversion: ctx.conversion,
            standards: ctx.standards,
            flagFilters: ctx.flagFilters,
            readings: ctx.readings,
            isInProgress: ctx.isInProgress
        }, "MixedDistributionWidget"),
    SummaryTableWidget: (ctx)=>/*#__PURE__*/ _jsx(SummaryTableWidget, {
            conversion: ctx.conversion,
            standards: ctx.standards,
            patientId: ctx.patientId,
            readings: ctx.readings,
            customRanges: ctx.customRanges,
            isInProgress: ctx.isInProgress
        }, "SummaryTableWidget"),
    ContentBar: (ctx)=>/*#__PURE__*/ _jsx(Fragment, {
            children: /*#__PURE__*/ _jsx("div", {
                className: styles.alertsContainer,
                children: ctx.renderContextAlerts && ctx.renderContextAlerts()
            })
        }, "ContentHeader"),
    KPIs: renderKpis,
    PatientHeader: (ctx)=>/*#__PURE__*/ _jsx(PrintableHeader, {
            patient: ctx.patient,
            accountPatientProfile: ctx.accountPatientProfile,
            activeClinicMembership: ctx.activeClinicMembership,
            isPatientMode: ctx.isPatientMode,
            startDate: ctx.startDate,
            endDate: ctx.endDate,
            days: ctx.days,
            kpis: renderKpis(ctx)
        }, "PatientHeader"),
    // Other props previously passed here (conversion, standards, calculationFormula, phiSet, accountPatientProfile)
    // were ignored by the component – it reads them from hooks/context.
    BloodGlucoseConcentrationReport: (ctx)=>/*#__PURE__*/ _jsx(BloodGlucoseConcentrationReport, {
            customRanges: ctx.customRanges
        }, "BloodGlucoseConcentrationReport"),
    GlucoseConcentrationLevelsWidget: (ctx)=>/*#__PURE__*/ _jsx(GlucoseConcentrationLevelsWidget, {
            readings: ctx.readings,
            start: ctx.start,
            end: ctx.end,
            isInProgress: ctx.isInProgress,
            onAddNote: ctx.onAddNote
        }, "GlucoseConcentrationLevelsWidget"),
    DaysSelector: (ctx)=>/*#__PURE__*/ _jsx(Widget, {
            widgetId: constants.DAYS_SELECTION_WIDGET,
            headerMessage: messages.headers.dailyGlucoseProfile,
            children: /*#__PURE__*/ _jsx(DailyGlucoseProfile, {
                patient: ctx.patient,
                isInProgress: ctx.isInProgress,
                onDatesChange: ctx.onDatesChange
            })
        }, "DaysSelectorWidget"),
    PrintableAgpBgmReport: (ctx)=>/*#__PURE__*/ _jsx(PrintableAgpBgmReport, {
            conversion: ctx.conversion,
            standards: ctx.standards,
            firstName: getPatientName(ctx, 'firstName'),
            lastName: getPatientName(ctx, 'lastName'),
            readings: ctx.readings,
            preMealReadings: ctx.preMealReadings,
            postMealReadings: ctx.postMealReadings,
            strictPreMealReadings: ctx.strictPreMealReadings,
            strictPostMealReadings: ctx.strictPostMealReadings,
            daysWithReadings: ctx.daysWithReadings,
            daysWithoutReadings: ctx.daysWithoutReadings,
            readingsWithoutFlag: ctx.readingsWithoutFlag,
            glucoseConcentrationLevelBottomValues: constants.GLUCOSE_CONCENTRATION_LEVELS_BOTTOM_VALUES
        }, "PrintableAgpBgmReport")
};
export const isWidgetName = (name)=>WIDGET_NAMES.includes(name);
export const renderWidget = (name, ctx)=>isWidgetName(name) ? widgetsRegistry[name](ctx) : null;
